<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 19C4.01 19 2 16.99 2 14.5C2 12.33 3.5 10.5 5.5 10.07C5.18 9.43 5 8.73 5 8C5 5.24 7.24 3 10 3C12.38 3 14.38 4.56 14.88 6.69C15.23 6.58 15.61 6.5 16 6.5C18.49 6.5 20.5 8.51 20.5 11C20.5 11.17 20.49 11.33 20.47 11.49C21.43 12.15 22 13.24 22 14.5C22 16.99 19.99 19 17.5 19H6.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
